import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

const List = async ({ assignableInInterfaceOnly = false } = {}) => {
  const params = assignableInInterfaceOnly ? { assignable_in_interface: true } : undefined
  return mainHTTPClient.get(MAIN_HTTP_API_ENDPOINTS.ROLES, { params })
}

const RolesService = {
  List
}

export default RolesService
